import React from 'react';
import BuildControl from './Build Control/BuildControl.jsx';
import classes from './BuildControls.css';

const controls = [
  { label: 'Lettuce (+$0.50)', type: 'lettuce' },
  { label: 'Meat (+$1.30)', type: 'meat' },
  { label: 'Cheese (+$0.40)', type: 'cheese' },
  { label: 'Bacon (+$0.70)', type: 'bacon' },
]

const buildControls = (props) => {
  return (


    <div className={classes.BuildControls}>
      <div className={classes.controlHeader}>Choose your ingredients</div>
      {controls.map(control => {
        return <BuildControl
          addIngredient={() => props.addIngredient(control.type)}
          removeIngredient={() => props.removeIngredient(control.type)}
          label={control.label}
          key={control.label}
          number={props.ingredients[control.type]} />
      })}

      <p className={classes.price}>Total: {`$${props.price.toFixed(2)}`}</p>
      <button className={classes.orderButton} disabled={!props.purchaseable} onClick={props.openModal}>ORDER NOW</button>
      <div className={classes.Footer}></div>
    </div>


    //   <BuildControl
    //     plus={() => props.plus('meat')}
    //     minus={() => props.minus('meat')}
    //     label='Meat'
    //     number={props.ingredients.meat} />
    //   <BuildControl
    //     plus={() => props.plus('salad')}
    //     minus={() => props.minus('salad')}
    //     label='Lettuce'
    //     number={props.ingredients.salad} />
    //   <BuildControl
    //     plus={() => props.plus('bacon')}
    //     minus={() => props.minus('bacon')}
    //     label='Bacon'
    //     number={props.ingredients.bacon} />
    //   <BuildControl
    //     plus={() => props.plus('cheese')}
    //     minus={() => props.minus('cheese')}
    //     label='Cheese'
    //     number={props.ingredients.cheese} />
    // </div>
  )
}

export default buildControls;


// WEBPACK FOOTER //
// ./src/components/Burger/BuildControls/BuildControls.jsx